import { tsValidateValue } from '@nu-art/ts-common';
import { findingRenderMethods } from './types.js';
export const Validator_FindingRenderMethod = tsValidateValue([...findingRenderMethods]);
//# sourceMappingURL=validation.js.map